// extracted by mini-css-extract-plugin
export default {"page":"x3-z","cartModal":"y3-z","checkout":"z3-z","placeholder":"A3-z","account":"B3-z"};